export default __webpack_public_path__ + "static/media/casualPhoto.cd295ce0.jpg";